// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__Clv3T","title":"style_title__EVonk","buttonContainer":"style_buttonContainer__DBMx2","button":"style_button__IuoTy"};